<template>
    <NuxtLayout class="bg-[#F7F6FB]" name="main" :dark="true">
        <div class="container relative flex pt-[56px]">
            <!-- * 侧栏区域 -->
            <div class="w-[320px] sticky top-[56px]">
                <!-- * 基础信息 -->
                <div class="p-[24px] rounded-[4px] bg-white flex items-center">
                    <img class="w-[64px] h-[64px] object-cover rounded-[50%]" :src="user.avatar" :alt="user.name" />
                    <div class="flex-1 w-0 ml-[16px]">
                        <div class="text-emphas text-[24px] leading-[40px] font-bold truncate">{{ user.name }}</div>
                        <div class="text-[14px] leading-[22px] truncate">{{ user.organization }}</div>
                    </div>
                </div>
                <!-- * 导航模块 -->
                <div class="px-[16px] py-[24px] mt-[16px] rounded-[4px] bg-white">
                    <template v-for="navigation in navigations" :key="navigation.icon">
                        <div
                            class="p-[8px] cursor-pointer rounded-[4px] truncate transition duration-200 hover:text-main"
                            :class="{ 'bg-color4 text-main font-bold': navigation.keys.includes($route.meta.route as never) }"
                            @click="methods.next(navigation)">
                            <ui-icon class="text-[16px] mr-[8px]" :name="navigation.icon" />
                            <span>{{ navigation.name }}</span>
                        </div>
                    </template>
                </div>
            </div>

            <!-- * 内容区域 -->
            <div class="flex-1 w-0 ml-[48px] bg-white" :class="{ 'px-[64px]': $route.meta.route != 'UserAgent' }">
                <router-view />
            </div>
        </div>
    </NuxtLayout>
</template>

<script lang="tsx" setup>
//* 组件库
import { UiIcon } from "various-ui";
//* 全局属性
import type { NavigateToRoute } from "@/utils/router/src/types";

//* 插件
const i18n = useI18n();
//* 持久化数据
const user = useUserStore();
//* 导航数据
const navigations = [
    { name: i18n.t("MyAccount"), icon: "account", keys: ["UserInfo", "UserLayout"], route: { name: "UserInfo" } },
    { name: i18n.t("RecentActivity"), icon: "history2", keys: ["UserRecentActivity"], route: { name: "UserRecentActivity" } },
    { name: i18n.t("Favorites"), icon: "star", keys: ["UserFavorites"], route: { name: "UserFavorites" } },
    { name: i18n.t("AIAgent"), icon: "agent", keys: ["UserAgent"], route: { name: "UserAgent" } },
    { name: i18n.t("Feedback"), icon: "feedback", keys: ["UserFeedback"], route: { name: "UserFeedback" } },
    {
        name: i18n.t("LogOut"),
        icon: "exit",
        keys: [],
        method: () => user.logout(),
    },
];

//* 函数列表
const methods = {
    next: (navigation: { route?: string | NavigateToRoute; method?: () => void }) => {
        if (navigation.route) routerPush(navigation.route);
        if (navigation.method) {
            navigation.method();
        }
    },
};
</script>
